import React from 'react';
import './button.scss';
import { joinClasses } from '../../../utils/helpers';

const ButtonGroup = (/** @type {{noGutter?: boolean; children: React.ReactNode; equal?: boolean; oneLine?: boolean; className?: string; }} */ { 
  noGutter = false, 
  children, 
  equal = false, 
  oneLine = false, 
  className = '' 
}) => {
  return (
    <div className={getClassNames(noGutter, equal, oneLine, className)}>
      {children}
    </div>
  );
};

const getClassNames = (/** @type {boolean} */ noGutter, /** @type {boolean} */ equal, /** @type {boolean} */ oneLine, /** @type {string} */ className) => {
  return joinClasses(
    'button-group',
    noGutter ? 'button-group--no-gutter' : '',
    equal ? 'button-group--equal' : '', 
    oneLine ? 'button-group--one-line' : '',
    className
  );
};


export default ButtonGroup;
